import React from 'react'
import Giro from '../../Images/icon-ec.svg'
import Bar from '../../Images/icon-barzahlung.svg'
import Vorkasse from '../../Images/icon-rechnung.svg'
import Waermekonto from '../../Images/icon-waermekonto.svg'


export const PaymentMethod = (props) => {

	const handleClick = (e, method, preis, kundennummer) => { 
		e.preventDefault()
		props.handlePayment(method, preis, kundennummer)
	}

	const setPaymentMethod = () => { 

		let button = ''
		switch (props.method) {
			case "ec":
				button = <button
					className={props.active === "ec" ? 'no__paymentbutton active' : 'no__paymentbutton '}
					onClick={e => handleClick(e, props.method, props.settings.aufpreisZahlung[props.method], false)}>
					<img src={Giro} alt="Girokarte" />Girokarte bei Lieferung
				</button>
				break
			case "bar":
				button = <button
					className={props.active === "bar" ? 'no__paymentbutton active' : 'no__paymentbutton '}
					onClick={e => handleClick(e, props.method, props.settings.aufpreisZahlung[props.method], false)}>
					<img src={Bar} alt="Barzahlung" />Barzahlung bei Lieferung
				</button>
				break
			case "rechnung":
				button = <button
					className={props.active === "rechnung" ? 'no__paymentbutton active' : 'no__paymentbutton '}
					onClick={e => handleClick(e, props.method, props.settings.aufpreisZahlung[props.method], true)}>
					<img src={Vorkasse} alt="Rechnung" />Rechnung (nur mit Kundennummer)
				</button>
				break
			case "garantie":
				button = <button
					className={props.active === "garantie" ? 'no__paymentbutton active' : 'no__paymentbutton '}
					onClick={e => handleClick(e, props.method, props.settings.aufpreisZahlung[props.method], true)}>
					<img src={Vorkasse} alt="Garantierte Zahlung" />Garantierte Zahlung (nur mit Kundennummer)
				</button>
				break
			case "vorkasse":
				button = <button
					className={props.active === "vorkasse" ? 'no__paymentbutton active' : 'no__paymentbutton '}
					onClick={e => handleClick(e, props.method, props.settings.aufpreisZahlung[props.method], false)}>
					<img src={Vorkasse} alt="Vorkasse" />Vorkasse
				</button>
				break
			case "waerme":
				button = <button
					className={props.active === "waerme" ? 'no__paymentbutton active' : 'no__paymentbutton '}
					onClick={e => handleClick(e, props.method, props.settings.aufpreisZahlung[props.method], true)}>
					<img src={Waermekonto} alt="Wärmekonto" />Wärmekonto (nur mit Kundennummer)
				</button>
				break
			case "lastschrift":
				button = <button
					className={props.active === "lastschrift" ? 'no__paymentbutton active' : 'no__paymentbutton '}
					onClick={e => handleClick(e, props.method, props.settings.aufpreisZahlung[props.method], false)}>
					<img src={Vorkasse} alt="Lastschrift" />Lastschrift
				</button>
				break
			default:
				button = ''
		}

		return button
	}

	return (
		<div className="no__paymentmethod">
			{setPaymentMethod()}
		</div>
	)
}
